import { render } from "./ColFormLabel.vue?vue&type=template&id=0ac9d19e"
import script from "./ColFormLabel.vue?vue&type=script&lang=js"
export * from "./ColFormLabel.vue?vue&type=script&lang=js"

import "./ColFormLabel.vue?vue&type=style&index=0&id=0ac9d19e&lang=css"

import exportComponent from "/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__